import { ForwardedRef, forwardRef, useImperativeHandle, useRef } from "react";
import FormControl from "../Form/FormControl";
import Validators from "../Form/Validators";
import LoginHelper from "./LoginHelper";
import TextInput, { ITextInput } from "../TextInput/TextInput";

export type TLoginFormProps = {
    onSubmit:React.KeyboardEventHandler
}
export interface ILoginForm {
    email:string
    password:string
}
export default forwardRef((props:TLoginFormProps, ref?:ForwardedRef<ILoginForm>) => {
    const refEmail = useRef<ITextInput|null>(null)
    const refPassword = useRef<ITextInput|null>(null)
    useImperativeHandle(ref, () => ({
        get email() { return refEmail.current?.value || ""},
        get password(){ return refPassword.current?.value || ""}
    }), [])
    return <>
        <FormControl validators={[Validators.Email()]}>
            <TextInput id="email" ref={refEmail} placeholder="E-mail" float={true} defaultValue={LoginHelper.get("email")} onUpdate={LoginHelper.onUpdate("email")}/>
        </FormControl>
        <FormControl validators={[Validators.Required("Password")]}>
            <TextInput id="password" ref={refPassword} placeholder="Password" float={true} inputProps={{type:"password"}} onSubmit={props.onSubmit}/>
        </FormControl>
    </>
})